import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconLightBulb = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={29}
    fill="none"
    viewBox="0 0 32 29"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-light-bulb_svg__a)">
      <path
        fill="url(#icon-light-bulb_svg__b)"
        d="M14.125 16.664v-.89h3.727v.89c0 .14-.047.281-.118.422l-.398.586a.832.832 0 0 1-.633.351h-1.43a.832.832 0 0 1-.632-.351l-.399-.586a.955.955 0 0 1-.117-.422Zm1.852-10.64a4.116 4.116 0 0 1 4.148 4.101c0 .984-.375 1.945-1.031 2.695-.399.446-.985 1.383-1.219 2.157V15h-3.773v-.023c-.235-.774-.82-1.711-1.22-2.157a4.092 4.092 0 0 1-1.007-2.695c0-2.18 1.71-4.102 4.102-4.102ZM16 8.273a.403.403 0 0 0 .375-.376.385.385 0 0 0-.375-.375c-1.453 0-2.625 1.172-2.625 2.602 0 .188.164.375.375.375a.403.403 0 0 0 .375-.375c0-1.031.82-1.852 1.875-1.852ZM11.125 10.5a.555.555 0 0 1-.563.563h-1.5A.542.542 0 0 1 8.5 10.5c0-.305.234-.563.563-.563h1.5a.57.57 0 0 1 .562.563Zm11.813-.563a.57.57 0 0 1 .562.563.555.555 0 0 1-.563.563h-1.5a.542.542 0 0 1-.562-.563c0-.305.234-.563.563-.563h1.5ZM11.57 7.313a.571.571 0 0 1 .282.492c0 .187-.118.375-.282.492-.187.094-.398.094-.562-.024l-1.313-.75a.571.571 0 0 1 0-.984.54.54 0 0 1 .563.024l1.312.75ZM22.281 13.5c.258.14.352.492.188.75a.526.526 0 0 1-.75.21l-1.313-.75a.571.571 0 0 1-.281-.491c0-.188.117-.375.281-.492.188-.094.399-.094.563.023l1.312.75Zm-11.273-.75a.526.526 0 0 1 .75.21c.14.259.07.61-.188.75l-1.312.75a.54.54 0 0 1-.563.024.571.571 0 0 1 0-.984l1.313-.75Zm9.703-4.406a.585.585 0 0 1-.563-.399c-.046-.258.047-.515.282-.633l1.289-.75a.526.526 0 0 1 .75.211c.164.258.07.586-.188.75l-1.289.75a.624.624 0 0 1-.281.07Z"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-light-bulb_svg__b"
        x1={22}
        x2={11.041}
        y1={6.5}
        y2={18.455}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6DF1E5" />
        <stop offset={0.18} stopColor="#4FC5BA" />
        <stop offset={0.73} stopColor="#26A69A" />
        <stop offset={1} stopColor="#1A746B" />
      </linearGradient>
      <filter
        id="icon-light-bulb_svg__a"
        width={31}
        height={28.023}
        x={0.5}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9221_33121"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9221_33121"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9221_33121"
          result="effect2_dropShadow_9221_33121"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9221_33121"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconLightBulb;
